import * as React from 'react'

import type { EmployeePictures } from 'modules/employees/store/collections/employeePictures'

const Context = React.createContext<EmployeePictures | null | undefined>(null)

export const EmployeePicturesProvider = ({
  collection,
  children,
}: {
  collection: EmployeePictures
  children: React.ReactNode
}) => <Context.Provider value={collection}>{children}</Context.Provider>

export const useEmployeePictures = (): EmployeePictures => {
  const EmployeePictures = React.useContext(Context)

  if (!EmployeePictures) {
    throw new Error('useEmployeePictures must be used within a EmployeePicturesProvider')
  }

  return EmployeePictures
}
